var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "color-switch" },
    _vm._l(_vm.colorClasses, function (option, key) {
      return _c("button", {
        key: key,
        staticClass: "tag",
        class: option,
        on: {
          click: function ($event) {
            $event.preventDefault()
            $event.stopPropagation()
            return _vm.$emit("input", option)
          },
        },
      })
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }